/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { Toaster } from "@workspace/ui/components/sonner";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { Providers } from "./providers/ConvexProvider";

function start() {
  const root = createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <Providers>
      <App />
      <Toaster />
    </Providers>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
